export default {
	app_install_banner_question: 'Install infra-struktur?',
	app_install_banner_question_choice_later: 'Update later',
	app_install_banner_question_choice_never: 'Never',
	app_install_banner_question_choice_yes: 'Update now',
	app_loading_indicator_downloading: 'Downloading...',
	app_loading_indicator_refreshing: 'Refreshing...',
	app_loading_indicator_searching: 'Searching...',
	app_loading_indicator_state_changing: 'State change is being performed...',
	app_login_failed: 'Your provided username and password combination is incorrect.',
	app_login_failed_ok_button_label: 'OK',
	app_login_failed_with_token: 'Your provided username, password and 2fa code combination is incorrect.',
	app_not_unlocked: 'Your user is not unlocked to use the infra-struktur app, please contact infra-struktur support.',
	app_not_unlocked_ok_button_label: 'OK',
	app_offline_banner: 'You have lost your Internet connection, the app is offline and cannot be used.',
	app_update_banner_question: 'Would you like to update the infra-struktur app?',
	app_update_banner_question_choice_later: 'Ask again in 4 hours',
	app_update_banner_question_choice_yes: 'Update now',
	app_version_mismatch_message:
		'Your app version is not compatible with the infra-struktur version. Please update the app.',
	app_version_mismatch_update_button: 'Update now',
};
